import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type FilterCategory } from '@strata/react-grid';

import { type ReferralSummary } from 'api/apertureAPI';

export interface ReferralListSliceState {
    pages: Record<number, ReferralSummary[]>;
    currentPage: number;
    npi?: string;
    referralCount?: number;
    filteredCount?: number;
    filterCategories?: FilterCategory<ReferralSummary>[];
}

const initialState: ReferralListSliceState = {
    pages: {},
    currentPage: 0,
    npi: undefined,
    referralCount: undefined,
    filteredCount: undefined,
    filterCategories: undefined,
};

export const referralListSlice = createSlice({
    name: 'referralList',
    initialState,
    reducers: {
        setCurrentPage(state, action: PayloadAction<{ currentPage: number }>) {
            const { currentPage } = action.payload;
            return { ...state, currentPage };
        },
        setPageData(state, action: PayloadAction<{ referrals: ReferralSummary[]; page: number }>) {
            const { referrals, page } = action.payload;
            return {
                ...state,
                pages: {
                    ...state.pages,
                    [page]: referrals,
                },
            };
        },
        setAdditionalReferralsData(
            state,
            action: PayloadAction<{
                npi?: string;
                referralCount?: number;
                filteredCount?: number;
                filterCategories?: FilterCategory<ReferralSummary>[];
            }>,
        ) {
            const { npi, referralCount, filteredCount, filterCategories } = action.payload;
            return {
                ...state,
                npi,
                referralCount,
                filteredCount,
                filterCategories,
            };
        },
        resetReferralData(state) {
            const { npi } = state;
            return { ...initialState, npi };
        },
    },
});

export const { setCurrentPage, setPageData, setAdditionalReferralsData, resetReferralData } =
    referralListSlice.actions;
